'use client';

// Mobile-only top header that contains the brand logo and the hamburger
// toggle that opens/closes the sidebar drawer. The actual sidebar lives
// in <SidebarNav />; this component just flips a class on <html> that the
// CSS in globals.css responds to (transform: translateX(0) for the aside,
// visibility:visible for the backdrop, overflow:hidden on body).
//
// Renders nothing on screens wider than 759px because the .mobile-header
// class is `display: none` by default and only enabled in the mobile
// breakpoint.

import { useEffect, useCallback } from 'react';

const OPEN_CLASS = 'sidebar-mobile-open';

export default function MobileHeader() {
    const close = useCallback(() => {
        if (typeof document !== 'undefined') {
            document.documentElement.classList.remove(OPEN_CLASS);
        }
    }, []);

    const toggle = useCallback(() => {
        if (typeof document !== 'undefined') {
            document.documentElement.classList.toggle(OPEN_CLASS);
        }
    }, []);

    // Close the drawer on Escape and on route changes (pathname change is
    // detected via popstate + the Link click being intercepted upstream;
    // here we just rely on Escape + backdrop click).
    useEffect(() => {
        function onKey(e) {
            if (e.key === 'Escape') close();
        }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [close]);

    // Close the drawer whenever the user clicks any link inside the sidebar.
    // We use event delegation on documentElement so we don't need to know
    // when the sidebar mounts.
    useEffect(() => {
        function onClick(e) {
            const a = e.target.closest && e.target.closest('aside nav a');
            if (a) close();
        }
        document.addEventListener('click', onClick);
        return () => document.removeEventListener('click', onClick);
    }, [close]);

    return (
        <>
            <header className="mobile-header">
                <div className="mh-logo" style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 22, letterSpacing: '-0.01em' }}>
                    <span>Optilink<span style={{ color: 'var(--blue)' }}>.</span></span>
                </div>
                <button
                    className="mh-burger"
                    type="button"
                    aria-label="Open navigation"
                    onClick={toggle}
                >
                    <span aria-hidden="true" style={{ lineHeight: 1, fontSize: 20 }}>☰</span>
                </button>
            </header>

            {/* Click-to-close backdrop, only visible when drawer is open. */}
            <div
                className="sidebar-backdrop"
                role="presentation"
                onClick={close}
            />
        </>
    );
}
